import React, {useContext} from "react"
import {Panel, DataRow} from "../PDFPrimitives"
import {PDFContext} from "../BasePDF"
import {withDocFee} from "../../../../utils/FeeHelper"

export const FeeBreakdownPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null

    const fees = withDocFee(pdfData.fees || [])

    return (
        <Panel title="Fee Breakdown">
            {fees.map((f) => (
                <DataRow key={f.id || f.name} label={f.name} value={f.amount.toDollarFormat()}/>
            ))}
            <DataRow
                label="Total Fees"
                value={pdfData.total_fees.toDollarFormat()}
                isTotal
                variant="bold"
                isLast
            />
        </Panel>
    )
}
